export default __webpack_public_path__ + "fonts/roboto-slab-700.woff";